import React, { Component } from 'react';
import { Container, Row, Col, Input, Button, Table, Spinner, UncontrolledTooltip } from 'reactstrap';

export class ForgotPassword extends Component {
    static displayName = ForgotPassword.name;

    render() {
        const logo = {
            width: '250px',
            padding: '1.5em',
            margin: '20px auto',
            display: 'block'
        }

        return (
            <Container>

                <Row style={{ marginTop: '20px', textAlign: 'center' }}>
                    <Col xl='4' lg='4' md='12' sm='12' xs='12'></Col>
                    <Col xl='4' lg='4' md='12' sm='12' xs='12'>
                        <div>
                            <img src="logo2.jpg" alt="logo" style={logo} />
                        </div>
                        <p>
                            Please enter your username below. We will send you an email with a link to reset your password.
                        </p>
                        <Input
                            type='text'
                            onChange={(e) => this.setState({ search: e.target.value })}
                            name='email'
                            id='email'
                            onKeyPress={this.handleKeyPress}
                            placeholder='Email Address'

                        />
                        <br />
                        <Button
                            color='primary'
                        >
                            Submit
                        </Button>
                    </Col>
                </Row>
            </Container>


        );
    }
}
